import { Routes } from '@angular/router';
import { AuthenticationGuard, AuthorizationGuard } from '@softline/auth';
import { MilchartikelService } from './services/milchartikel.service';
import { MilchartikelRepository } from './repositories/milchartikel.repository';
import { RohstoffbereitstellungDetailService } from './services/detail.service';
import { RohstoffbereitstellungDetailRepository } from './repositories/detail.repository';
import { LagerlistenVerbrauchService } from './services/lagerlisten-verbrauch.service';
import { LagerlistenVerbrauchRepository } from './repositories/lagerlisten-verbrauch.repository';
import { FetteinheitenRechnerRepository } from './repositories/fetteinheiten-rechner.repository';
import { FetteinheitenRechnerService } from './services/fetteinheiten-rechner.service';
import { QueryDetailService, QueryService } from './services/query.service';

export const rohstoffbereitstellungRoutes: Routes = [
  {
    path: 'rohstoffbereitstellung',
    providers: [
      QueryService,
      QueryDetailService,

      MilchartikelRepository,
      MilchartikelService,

      LagerlistenVerbrauchRepository,
      LagerlistenVerbrauchService,

      FetteinheitenRechnerRepository,
      FetteinheitenRechnerService,

      RohstoffbereitstellungDetailRepository,
      RohstoffbereitstellungDetailService,
    ],
    loadComponent: () => import('./pages/rohstoffbereitstellung.component'),
    children: [
      {
        path: 'start',
        loadComponent: () => import('./pages/start-wizard/start-wizard.component'),
      },
      {
        path: '',
        loadComponent: () => import('./pages/dashboard/dashboard.component'),
      },
      {
        path: '**',
        redirectTo: '/rohstoffbereitstellung/start',
      },
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    // data: { permission: SOFTLINE_PERMISSION_MILCHMENGENRECHNER }
  },
];
